/** Applied again in the browser so a cached page cannot keep an expired Story on screen. */
export function liveSocialPosts<T extends { expiresAt?: string | null }>(
  posts: T[],
  now: number
): T[] {
  return posts.filter((post) => !post.expiresAt || Date.parse(post.expiresAt) > now)
}
